__turbopack_context__.v({
  "navigationLink": "_M96lW_navigationLink",
  "navigationLink--active": "_M96lW_navigationLink--active",
  "navigationLink--compact": "_M96lW_navigationLink--compact",
});
